import { FC } from 'react'
import { CustomizationProps } from './CartProductCards'

interface ProductExtraProps {
  customizations: CustomizationProps
  className?: string
}
const ProductExtraInfo: FC<ProductExtraProps> = ({ customizations, className }) => {
  return (
    <div className={`label_small text-neutral-700 flex-col ${className}`}>
      {customizations.textInput?.map((textCustomization) => (
        <div key={textCustomization.title}>
          <span className="label_medium"> {textCustomization.title}:</span>{' '}
          {textCustomization.content}
        </div>
      ))}

      {customizations.dropDowns?.map((drop) => (
        <div key={drop.title}>
          <span className="label_medium"> {drop.title}:</span> {drop.choice.choice}
        </div>
      ))}

      {customizations.stepper ? (
        <div>
          <span className="label_medium">{customizations.stepper.title}:</span>{' '}
          {customizations.stepper.count}
        </div>
      ) : undefined}
    </div>
  )
}

export default ProductExtraInfo
